import { Component, Input } from '@angular/core';
import { BuildDetailsDto, OaiboxTelemetryDto, WebAppCommonModule } from "@allbesmart/web-app-common";
import { DatePipe } from '@angular/common';

@Component({
    selector: 'oaibox-build-details',
    templateUrl: './build-details.component.html',
    styleUrls: ['./build-details.component.css'],
    imports: [WebAppCommonModule, DatePipe]
})
export class BuildDetailsComponent {

  @Input() buildDetails?: BuildDetailsDto;
  @Input() oaiboxTelemetry?: OaiboxTelemetryDto;

}
